import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseFileService } from './base-file.service';

@Injectable({
  providedIn: 'root',
})
export class ImagesService extends BaseFileService {
  baseUrl = environment.apiUrl + '/Files';
  SINGLE_FILE_UPLOAD_URL = this.baseUrl;
  MULTIPLE_FILE_UPLOAD_URL = this.baseUrl + '/PostMultiple';

  constructor(@Inject(HttpClient) http) {
    super(http);
  }

  getFileUrl(fileId: string, width?: number, height?: number): string {
    if (fileId.startsWith('https://')) {
      return fileId;
    }
    if (width && height) {
      return `${this.baseUrl}/previewimage/${fileId}?w=${width}&h=${height}`;
    } else {
      return `${this.baseUrl}/${fileId}`;
    }
  }
}
